const IMG_URL = import.meta.env.VITE_IMG_BASE_URL

export const getImgUrl = (url: string, imgType = ''): string => {
  return `${IMG_URL}/widget-dist/${url}${imgType !== '' ? '.' : ''}${imgType}`
}

// 用这个，目前所有url都是拼接形式的，不会出现纯数字
export function getNumberFromUrl(str: string): string {
  const num = str.split('/').pop()?.split('?')[0] ?? 'error'
  if (num !== 'error' && num.length < 8) {
    return getImgUrl(`avatar/avatar-${num}`, 'png')
  } else {
    return str
  }
}

export function getColorByKey(key: number) {
  if (key >= 0 && key < 10) {
    switch (key) {
      case 0:
        return '#FF8A4C'
      case 1:
        return '#F5B200'
      case 2:
        return '#8FD600'
      case 3:
        return '#05D16B'
      case 4:
        return '#00CCB6'
      case 5:
        return '#00BCFF'
      case 6:
        return '#51A2FF'
      case 7:
        return '#7C86FF'
      case 8:
        return '#A684FF'
      case 9:
        return '#C27AFF'
    }
  } else {
    console.warn('默认头像背景颜色计算错误：' + key)
    return 'black'
  }
}

export function uuidToNumber(uuid: string) {
  let hash = 0
  for (let i = 0; i < uuid.length; i++) {
    hash = (hash << 5) - hash + uuid.charCodeAt(i)
    hash |= 0 // 转换为 32 位整数
  }
  return Math.abs(hash) % 10
}
